import { Container } from './NodataStyles';
import caution from '@/assets/caution.svg';

interface NodataProps {
  desc?: string;
  className?: string;
}

export const Nodata = ({ desc, className }: NodataProps) => {
  return (
    <Container className={className}>
      <img src={caution} alt="caution" />
      <div className="text-sm text-text-300 ml-2">{desc}</div>
    </Container>
  );
};

export default Nodata;
